module.exports = "<app-commonheader></app-commonheader>\n<h1>page not found</h1>\n<app-footer></app-footer>\n"